import React, { Component } from 'react'
import { NewButton } from '../shared/NewButton'
import { NavLink } from 'react-router-dom'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import plusSquare from '@fortawesome/fontawesome-free-solid/faPlusSquare'
import '../stylesheets/products.sass'
import noProducts from '../images/NoProducts.png'
import { Image } from '../Products/image'

export default class NoProducts extends Component {

    render() {
      return (
        <div className={'welcome-wrapper row'}>
          <div className={'column one'}>
            &nbsp;
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} className={'column two reservation-welcome'}>
            <Image
              image_url={ noProducts }
              imageClass='product-update-image'
              height='100'
              width='90'
            />
            <div style={{ marginTop: 30, fontSize: 18, fontWeight: 400, color: '#A0A0A0' }} className={'row'}>
              No products yet
            </div>
            <div style={{ color: '#4D4D4D' }} className={'row'}>
              Add products, including beer types, sizes and prices so your customers can reserve and order kegs online.
            </div>
          </div>
          <div className={'column three'}>
            &nbsp;
          </div>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Products/NoProducts.jsx